import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/topics', parameters);
    }

    async getAll(params = {}) {
        return this.submit('get', '/all', params);
    }


    async updateTopicStatus(id, params = {}) {
        return this.submit('post', `/update/status/${id}`, params);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/Topic.js